<h2 mat-dialog-title class="bgDialogHeader text-center">Add Additional Users
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content class="mat-typography">
  <ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
  <div class="col-md-12">
    <form class="form-horizontal" [formGroup]="formInviteUser">
      <div class="col-md-6">
        <mat-form-field>
          <input type="text" class="w-100" formControlName="inviteUserFName" placeholder="First Name" matInput required>
        </mat-form-field>
        <div *ngIf="formInviteUser.controls.inviteUserFName.touched && formInviteUser.controls.inviteUserFName.errors"
          class="error">
          <div *ngIf="formInviteUser.controls.inviteUserFName.errors.required">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              First name is required
            </div>
          </div>
          <div *ngIf="formInviteUser.controls.inviteUserFName.errors.pattern">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              First name must contain alphabets and must not begin with space
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <mat-form-field>
          <input type="text" class="w-100" formControlName="inviteUserLName" placeholder="Last Name" matInput required>
        </mat-form-field>
        <div *ngIf="formInviteUser.controls.inviteUserLName.touched && formInviteUser.controls.inviteUserLName.errors"
          class="error">
          <div *ngIf="formInviteUser.controls.inviteUserLName.errors.required">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              Last name is required
            </div>
          </div>
          <div *ngIf="formInviteUser.controls.inviteUserLName.errors.pattern">
            <div class="alert custom-alert-danger" role="alert">
              <span class="sr-only">Error:</span>
              Last name must not begin with space
            </div>
          </div>
        </div>
      </div>
      <mat-form-field class="col-md-12">
        <mat-select placeholder="User Hierarchy" (selectionChange)="showLocation($event);"
          formControlName="inviteUserHierarchy" required>
          <mat-option *ngFor="let item of userHierachy" [value]="item.value" [attr.view]="item.key"
            [disabled]="isBubbleCall == true && bubbleHierarchy != item.value">
            {{item.value}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-md-12">
        <mat-select placeholder="User Association" formControlName="userAssociation" required>
          <ng-container *ngFor="let item of userHierachyAssociation" required>
            <mat-option [value]="item.customerKey" [attr.view]="item.customerKey"
              *ngIf="(isBubbleCall == true && bubbleCustomerKey == item.customerKey) || (isBubbleCall == false)">
              {{item.customerName}}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <div class="error col-md-12" *ngIf="errorAssociation">
        <div class="alert alert-warning" role="alert">
          {{errorMsgUserAssociation}}
        </div>
      </div>
      <mat-form-field class="col-md-12">
        <mat-select (selectionChange)="getApprovalLimit($event);" placeholder="Company Role (not required)"
          formControlName="inviteUserCompanyRole">
          <mat-option *ngFor="let rol of CompanyRole;" [value]="rol.companyRoleKey">
            {{ rol.roleDescription }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="error col-md-12" *ngIf="errorCompanyRole">
        <div class="alert alert-warning" role="alert">
          {{errorMsgCompanyRole}}
        </div>
      </div>
      <mat-form-field class="col-md-12" *ngIf="showPriority">
        <mat-select placeholder="Priority" formControlName="inviteUserPriority" required>
          <mat-option *ngFor="let priority of arrPriorities;" [value]="priority">
            {{ priority }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-md-12">
        <mat-select placeholder="View" formControlName="inviteUserView" required>
          <mat-option *ngFor="let rol of Roles;" [value]="rol.userRoleGroupId">
            {{ rol.userRoleGroupName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-md-12">
        <input type="text" (change)="removeError()" formControlName="inviteUserEmail" class="w-100" placeholder="Email"
          matInput required>
      </mat-form-field>
      <div *ngIf="formInviteUser.controls.inviteUserEmail.touched && formInviteUser.controls.inviteUserEmail.errors"
        class="error col-md-12">
        <div *ngIf="formInviteUser.controls.inviteUserEmail.errors.required">
          <div class="alert custom-alert-danger" role="alert">
            <span class="sr-only">Error:</span>
            Email is required
          </div>
        </div>
        <div *ngIf="formInviteUser.controls.inviteUserEmail.errors.uniqueEmail">
          <div class="alert custom-alert-danger" role="alert">
            <span class="sr-only">Error:</span>
            Email already exists.
          </div>
        </div>
        <div *ngIf="formInviteUser.controls.inviteUserEmail.errors.pattern">
          <div class="alert custom-alert-danger" role="alert">
            <span class="sr-only">Error:</span>
            Email must be a valid email address
          </div>
        </div>
      </div>
      <div class="error col-md-12" *ngIf="errorId == 102 || errorId == 101">
        <div class="alert custom-alert-danger" role="alert">
          {{errorMsgEmail}}
        </div>
      </div>
      <mat-form-field class="col-md-12">
        <input type="text" formControlName="inviteUserPhone" class="w-100" placeholder="Cell Phone"
          (change)="getlength($event)" matInput>
      </mat-form-field>
      <div *ngIf="formInviteUser.controls.inviteUserPhone.touched && formInviteUser.controls.inviteUserPhone.errors"
        class="error col-md-12">
        <div *ngIf="!mobileError && formInviteUser.controls.inviteUserPhone.errors.pattern">
          <div class="alert custom-alert-danger" role="alert">
            <span class="sr-only">Error:</span>
            Cell Phone number should contain 10 digits
          </div>
        </div>
      </div>
      <div class="error col-md-12" *ngIf="mobileError">
        <div class="alert custom-alert-danger" role="alert">
          <span class="sr-only">Error:</span>
          Cell Phone number should contain 10 digits
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [disabled]="formInviteUser.invalid" (click)="InviteNewUser()"
    class="col-md-2 btn btn-semi-round bgBlue mr-2 mb-1 pull-right">
    Invite User
  </button>
</mat-dialog-actions>